import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { PaymentMethod, PaymentMethodType } from '@pedix-workspace/utils';

@Injectable({
  providedIn: 'root',
})
export class InitialDataService {
  private t = inject(TranslocoService);

  constructor() {}

  get initialPaymentMethods(): PaymentMethod[] {
    return [
      {
        removable: false,
        name: this.t.translate('global.paymentMethodCash'),
        active: true,
        type: PaymentMethodType.CASH,
        priceModifier: 'none',
      },
      {
        removable: false,
        name: this.t.translate('global.paymentMethodCard'),
        active: true,
        type: PaymentMethodType.CARD,
        priceModifier: 'none',
      },
      {
        removable: false,
        name: this.t.translate('global.paymentMethodTransfer'),
        active: false,
        type: PaymentMethodType.TRANSFER,
        priceModifier: 'none',
      },
    ];
  }
}
